import { GuideStepType } from 'components/guide/models'
import { useLocation } from 'react-router-dom'
import { GuideStore } from 'components/guide/GuideStore'

export function useGuideStep(): GuideStepType | null {
  const location = useLocation()
  return GuideStore.getStepByPathName(location.pathname)
}
